import React from 'react'

function ShipBuilderPromo() {
    return (
        <section style={{paddingTop: '80px', paddingBottom: '80px'}}>
            <div className="container">
                <div className="row align-items-center">
                    <div className="col-lg-6 mb-4 mb-lg-0">
                        <div className="section-title mb-4">
                            <h2>Starpath <span>Ship Yards</span></h2>
                        </div>
                        <p style={{fontSize: '1.1rem', lineHeight: '1.8', marginBottom: '1.5rem'}}>
                            Step into the role of an interstellar engineer. Design and construct unique starships
                            with an intuitive blueprint tool that offers unprecedented customization &mdash; from
                            hull shapes and propulsion systems to weaponry and aesthetic details.
                        </p>
                        <div className="row" style={{marginBottom: '1.5rem'}}>
                            <div className="col-sm-6 mb-3">
                                <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
                                    <i className="fas fa-drafting-compass" style={{color: '#e4a101', fontSize: '1.4rem', marginTop: '3px'}} />
                                    <div>
                                        <h6 style={{marginBottom: '4px'}}>Blueprint Tool</h6>
                                        <p style={{fontSize: '0.9rem', opacity: 0.8, marginBottom: 0}}>
                                            Select from diverse components across multiple manufacturers
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 mb-3">
                                <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
                                    <i className="fas fa-rocket" style={{color: '#e4a101', fontSize: '1.4rem', marginTop: '3px'}} />
                                    <div>
                                        <h6 style={{marginBottom: '4px'}}>Test in Space</h6>
                                        <p style={{fontSize: '0.9rem', opacity: 0.8, marginBottom: 0}}>
                                            Simulate your designs in real interstellar scenarios
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 mb-3">
                                <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
                                    <i className="fas fa-unlock-alt" style={{color: '#e4a101', fontSize: '1.4rem', marginTop: '3px'}} />
                                    <div>
                                        <h6 style={{marginBottom: '4px'}}>Unlock & Progress</h6>
                                        <p style={{fontSize: '0.9rem', opacity: 0.8, marginBottom: 0}}>
                                            Discover advanced components as your skills evolve
                                        </p>
                                    </div>
                                </div>
                            </div>
                            <div className="col-sm-6 mb-3">
                                <div style={{display: 'flex', alignItems: 'flex-start', gap: '10px'}}>
                                    <i className="fas fa-users" style={{color: '#e4a101', fontSize: '1.4rem', marginTop: '3px'}} />
                                    <div>
                                        <h6 style={{marginBottom: '4px'}}>Community</h6>
                                        <p style={{fontSize: '0.9rem', opacity: 0.8, marginBottom: 0}}>
                                            Share designs, get feedback, and collaborate
                                        </p>
                                    </div>
                                </div>
                            </div>
                        </div>
                        <a
                            href="/shipyards"
                            className="btn"
                            style={{
                                background: 'linear-gradient(135deg, #e4a101, #d4880f)',
                                color: '#fff',
                                padding: '12px 32px',
                                borderRadius: '6px',
                                fontWeight: 'bold',
                                fontSize: '1rem',
                                textTransform: 'uppercase',
                                letterSpacing: '1px',
                            }}
                        >
                            Launch Ship Yards <i className="fas fa-external-link-alt" style={{marginLeft: '8px'}} />
                        </a>
                    </div>
                    <div className="col-lg-6">
                        <div style={{
                            display: 'grid',
                            gridTemplateColumns: '1fr 1fr',
                            gap: '10px',
                        }}>
                            <div style={{borderRadius: '8px', overflow: 'hidden', gridRow: '1 / 3'}}>
                                <img
                                    src="https://doubtech-photo-storage.s3.us-west-2.amazonaws.com/1771716940128-image.png"
                                    alt="Ship Builder"
                                    loading="lazy"
                                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                />
                            </div>
                            <div style={{borderRadius: '8px', overflow: 'hidden'}}>
                                <img
                                    src="https://doubtech-photo-storage.s3.us-west-2.amazonaws.com/1771716926825-image.png"
                                    alt="Ship Builder"
                                    loading="lazy"
                                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                />
                            </div>
                            <div style={{borderRadius: '8px', overflow: 'hidden'}}>
                                <img
                                    src="https://doubtech-photo-storage.s3.us-west-2.amazonaws.com/1771716914889-image.png"
                                    alt="Ship Builder"
                                    loading="lazy"
                                    style={{width: '100%', height: '100%', objectFit: 'cover'}}
                                />
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </section>
    )
}

export default ShipBuilderPromo
